import { ReactNode } from 'react'
import styles from './ModalButtonLayout.module.scss'

interface Props {
  children: ReactNode
  isActive?: boolean
  clickEvent: () => void
  buttonStyle?: string
}

const ModalButtonLayout: React.FC<Props> = ({
  children,
  isActive,
  clickEvent,
  buttonStyle,
}: Props): JSX.Element => {
  return (
    <button
      className={`${styles.defaultButton} ${buttonStyle}`}
      disabled={isActive}
      onClick={clickEvent}
    >
      {children}
    </button>
  )
}

export default ModalButtonLayout
